import React from 'react';
import {nonEmpty} from "../util/LangUtil";

import {ConsignmentWaypointResponse} from "../services/ConsignmentService";

type ConsignmentWaypointDescriptionProps = {
    waypoint: ConsignmentWaypointResponse
}

const ConsignmentWaypointDescription = ({waypoint} : ConsignmentWaypointDescriptionProps) => {


    return (
        <>
            {// @ts-ignore - Typescript barfs at this template function
            nonEmpty`${waypoint.address.unitOrFlat} ${waypoint.address.street}`}<br />
            {// @ts-ignore - Typescript barfs at this template function
            nonEmpty`${waypoint.address.suburb} ${waypoint.address.state} ${waypoint.address.postcode}`}
        </>
    )

};

export default ConsignmentWaypointDescription;